import React from "react";
import TextAccordion from "./textAccordion";

const TextAccordionNestedList = ({
  accordionList,
  containerClass,
  extraClass,
  isOpenTag
}) => {
  return (
    <>
      {accordionList && accordionList?.length > 0 && (
        <>
          {accordionList.map((parent, index) => (
            <div key={index} className={containerClass}>
              <div
                className={`w-11/12 md:w-9/12 py-5 ${
                  index === 0 ? "pt-14" : "pt-6"
                } ${
                  index === accordionList.length - 1 ? extraClass : "pt-0"
                } mx-auto`}
              >
                {parent?.sectionTitle && (
                  <h2
                    className="pb-10"
                    dangerouslySetInnerHTML={{ __html: parent?.sectionTitle }}
                  />
                )}

                {parent?.sectionDesc && (
                  <div
                    className="pb-10"
                    dangerouslySetInnerHTML={{ __html: parent?.sectionDesc }}
                  />
                )}

                <div className="overflow-y-auto md:pr-11 md:gvi-scrollbar-thin md:max-h-114">
                  {parent?.accordionList.map((item, index) => (
                    <TextAccordion
                      data={item}
                      key={index}
                      isOpenTag={isOpenTag}
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default TextAccordionNestedList;

TextAccordionNestedList.defaultProps = {
  containerClass: "w-full flex bg-white dark:bg-gray-darkest"
};
